import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { printMessage } from 'src/app/constants/service.constants';
import { IstUserInstructionsModalComponent } from './ist-user-instructions-modal/ist-user-instructions-modal.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { DateObject, IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectApplicationtypeModelComponent } from 'src/app/common/operations-bar/select-applicationtype-model/select-applicationtype-model.component';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { ColumnsSelectionPopupComponent, UserPreferenceColumns, UserPreferenceColumnsList } from 'src/app/common/columns-selection-popup/columns-selection-popup.component';

@Component({
  selector: 'app-ist-my-applications',
  templateUrl: './ist-my-applications.component.html',
  styleUrls: ['./ist-my-applications.component.scss']
})
export class IstMyApplicationsComponent implements OnInit {
  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs: any[];
  operations: any[];
  tempoperations: any[];
  rowData;
  advanceSearch: any;
  selectedRow;
  caseDetails;
  studyType: any[];
  requestType: any[];
  StatusList: any;
  TherapeuticAreaList: any[];
  ApplicationTypeList: any[];
  productList: any[];
  IStApplicationsSearch: UntypedFormGroup;
  istapp: IST_APP;
  maxDate: Date = new Date();
  menudata: ModuleMenu;
  userType: string = "";
  isProduct: boolean = false;
  myDate = new Date();
  Instruction_Status: boolean;
  isHadPermission: boolean = false;
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();
  orgDetails: any;
  IST_Display_Name: any;
  Grants_Display_Name: any;
  columns:any;
  userPreferenceColumnsLst: UserPreferenceColumnsList;
  ApplicationID:string = '';
  ApplicationType:string = '';
  PhysicianName:string = '';
  TherapeuticArea:string = '';
  RequestType:string = '';
  Product:string = '';
  StudyType:string = '';
  Owner:string = '';
  Status:string = '';
  //SDates:any;
  //EDates:any;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private commonService: CommonService,
    private header: HeadService,
    private userService: UserService,
    private GrantsService : GrantsSummaryService,

  ) {

  }

  ngOnInit() {
    this.columns = this.route.snapshot.data["items"][0];
    if(this.route.snapshot.data["items"][1] != null){
      this.userPreferenceColumnsLst = this.route.snapshot.data["items"][1];
    }
    this.requestType = [{ "value": "", "label": "All" }, { "value": "1", "label": "Funds" }, { "value": "2", "label": "Product" }, { "value": "3", "label": "Both" }];

    this.orgDetails = this.commonService.getOrgDetails();
    this.IST_Display_Name = this.orgDetails[0].IST_DISPLAY_NAME;
    this.userType = this.userService.getUserType();
    this.IStApplicationsSearch = new UntypedFormGroup({
      Title: new UntypedFormControl(""),
      ApplicationType: new UntypedFormControl(""),
      PhysicianName: new UntypedFormControl(""),
      TherapeuticArea: new UntypedFormControl(""),
      RequestType: new UntypedFormControl(""),
      Product: new UntypedFormControl(""),
      StudyType: new UntypedFormControl(""),
      Assignedto: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      StartDateO: new UntypedFormControl(null),
      EndDateO: new UntypedFormControl(null)

    });

    if (this.userType === "E") {
      this.tempoperations = [
        {
          "name": "New Application",
          "id": "add"
        }
      ]

    }
    else
      this.tempoperations = [];

    this.operations = this.tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } :
        { name: operation.name, callback: this[operation.id], self: this }
    });
    this.advanceSearch = {
      "fields": [
        {
          "label": "Title",
          "field": "title",
          "type": "text"
        },
        {
          "label": "Application type",
          "field": "ApplicationType",
          "type": "dropdown",
          "options": this.ApplicationTypeList,
        },
        {
          "label": "Physician Name",
          "field": "PhysicianName",
          "type": "text"
        },
        {
          "label": "Therapeutic Area",
          "field": "TherapeuticArea",
          "type": "dropdown",
          "options": this.TherapeuticAreaList,
        },
        {
          "label": "Study Type",
          "field": "StudyType",
          "type": "dropdown",
          "options": this.studyType,
        },
        {
          "label": "Request Type",
          "field": "RequestType",
          "type": "dropdown",
          "options": this.requestType,
        },
        {
          "label": "Product",
          "field": "Product",
          "type": "dropdown",
          "options": this.productList,
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown",
          "options": this.StatusList,
        }
      ],
      "filters": [
        {
          "label": "New Applications in last one week",
          "filter_key": "unique_key_1",
          "criteria": ""
        },
        {
          "label": "New Applicaitons in last one month",
          "filter_key": "unique_key_2",
          "criteria": ""
        },
        {
          "label": "New Applications in last one quarter",
          "filter_key": "unique_key_3",
          "criteria": ""
        },
        {
          "label": "New Applications in last one year",
          "filter_key": "unique_key_4",
          "criteria": ""
        }
      ]
    };
    if (this.userType == 'I') {
      let hadeditPermission = this.commonService.getScreenPermission("202", "E");
      if (hadeditPermission) {
        this.isHadPermission = true;
      }
      this.setUserPreferenceColumns();
      this.caseDetails = [
        {
          "caseSet": {
            "caseHeading": "General",
            "caseData": [
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Physician Name",
                "value": "PhysicianName"
              },
              {
                "label": "Study Sponsored",
                "value": "StudySponceredBy"
              },
              {
                "label": "Therapeutic Area",
                "value": "THERAPEUTIC_AREA_NAME"
              },
              {
                "label": "Request Type",
                "value": "REQUEST_TYPE_NAME"
              },
              {
                "label": "Product",
                "value": "PRODUCT_NAME"
              },
              {
                "label": "Study Type",
                "value": "StudyType"
              },
              {
                "label": "Status",
                "value": "STATUSStr"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              {
                "label": "Last Updated On",
                "value": "LastUpdatedStr"
              },
              {
                "label": "IRB Name",
                "value": "IRBName"
              },
              {
                "label": "#Total Requests",
                "value": "totalRequests"
              },
              {
                "label": "#Closed Requests",
                "value": "closedRequests"
              }
            ]

          }
        }
      ]
    }
    else if (this.userType == 'E') {
      this.isHadPermission = true;
      this.setUserPreferenceColumns();
      this.caseDetails = [
        {
          "caseSet": {
            "caseHeading": "General",
            "caseData": [
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Study Sponsored",
                "value": "StudySponceredBy"
              },
              {
                "label": "Therapeutic Area",
                "value": "THERAPEUTIC_AREA_NAME"
              },
              {
                "label": "Request Type",
                "value": "REQUEST_TYPE_NAME"
              },
              {
                "label": "Product",
                "value": "PRODUCT_NAME"
              },
              {
                "label": "Study Type",
                "value": "StudyType"
              },
              {
                "label": "Status",
                "value": "STATUSStr"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              {
                "label": "Last Updated On",
                "value": "LastUpdatedStr"
              },
              {
                "label": "IRB Name",
                "value": "IRBName"
              },
              {
                "label": "#Total Requests",
                "value": "totalRequests"
              },
              {
                "label": "#Closed Requests",
                "value": "closedRequests"
              }
            ]

          }
        }
      ]
    };

    this.getSummaryData();
    this.GetStatusList();
    this.getApplicationtypes();
  }
  GetStatusList() {
    this.summaryService.masterData("api/gmapp/getstatus/2").subscribe(result => {
      if (result != null) {
        this.StatusList = result;
        this.StatusList = [{ label: "Select", value: "-1", checked: true }, { label: "Returned", value: "Returned", checked: true }].concat(this.StatusList);

      }
    });
  }
  requestTypeChange(event) {
    let requestType = event.value;
    if (requestType != 1) { this.isProduct = false }
    else { this.isProduct = true }
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    switch(event.operationType){
      case 'edit':
        this.commonService.refreshApplicationPage(event.data["ID"],"ist");
        break;
      case 'rfi':
        this.commonService.LaunchingRequiredScreen(event.data["ID"],"ist","rfi_request");
        break;
      case 'mail':
        this.commonService.LaunchingRequiredScreen(event.data["ID"],"ist","correspondence_request");
        break;
    }
  }
 
  Submit_from_date: DateObject;
  Submit_end_date: DateObject;
  // isfromDateModefied : boolean = false;
  // isendDateModified : boolean = false;
  submitfromDate(event) {
    this.IStApplicationsSearch.controls["EndDate"]?.setValue(null);
    this.Submit_from_date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      HasValue: true

    };
  }
  submitendDate(event) {
    this.Submit_end_date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      HasValue: true

    }

  }


  print() {
    const modalRef = this.modalService.open(MessageBoxComponent, {
    });
    modalRef.componentInstance.Content = {
      operation: { hasOpr: false },
      heading: 'Print Application',
      content: { heading: '', description: printMessage }
    }
  }

  add() {
    const modalRef = this['self'].modalService.open(SelectApplicationtypeModelComponent, { backdrop: false, windowClass: 'modal-md pt-5' });
    modalRef.componentInstance.Content = {
      heading: 'Select Application Type',
      custommessage: '',
      Proceed: "Proceed",
      Cancel: "Cancel",
      ModuleID:"2"
    }
    modalRef.result.then(result => {
      debugger;
      //  let  flag = false;
      this['self'].GrantsService.getInstruction(result).subscribe(summary => {
        if (summary['isINSTRUCTIONS_ID']) {  //this['self'].Instruction_Status && 
          const ModelRef = this['self'].modalService.open(IstUserInstructionsModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-lg right modal-right',
            animation: true
          })
          ModelRef.componentInstance.Content = {
            id: "",
            ApplicationType: result
          }
        }
        else {
          debugger;
          this['self'].commonService.refreshApplicationPage("", "ist",result);
        }
      });
    });
  }

  getSummaryData() {
    this.SearchClear();
    this.summaryService.getApplicationSummary("api/ISTMyApplications/GetMyApplicationsList").subscribe(summary => {
      this.rowData = summary["SummaryData"];
      this.studyType = summary["MasterDrops"].MasterData1;
      this.studyType = [{ label: "Select", value: "", checked: true }].concat(this.studyType);
      this.TherapeuticAreaList = summary["MasterDrops"].MasterData2;
      this.TherapeuticAreaList = [{ label: "All", value: "", checked: true }].concat(this.TherapeuticAreaList);
      this.productList = summary["MasterDrops"].MasterData3;
      this.productList = [{ label: "Select", value: "", checked: true }].concat(this.productList);
      this.Instruction_Status = summary.Instruction_Status;
      this.requestType= summary["MasterDrops"].MasterData4;
      this.requestType = [{ label: "Select", value: "", checked: true }].concat(this.requestType);
    });
  }

  getApplicationtypes() {
    let submodule = "-1";
    let moduleID = "2";
    this.commonService.getAllApplicationTypesforSearch(moduleID, submodule).subscribe((result) => {
      if (result) {
        this.ApplicationTypeList = result;
      }
    });
  }
  getSummarySearch(searchObject: any) {
    this.summaryService.getISTSearchSummary("api/ISTMyApplications/getMySummarySearch", searchObject).subscribe(summary => {
      this.rowData = summary["SummaryData"];
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.IStApplicationsSearch.reset();
  }
  AdvanceSearch() {
    var formData = this.IStApplicationsSearch.value;
    if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') {
      //formData["StartDate"] = new Date(formData["StartDate"]);
      formData["StartDateO"] = this.Submit_from_date;
    }
    if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {

      // formData["EndDate"] = new Date(formData["EndDate"]);
      formData["EndDateO"] = this.Submit_end_date;
    }
    this.getSummarySearch(formData);
  }


  setUserPreferenceColumns(){
    this.columnDefs = [];
    this.columns.forEach(x=>{
      if(x.FieldCode == 'APPLICATION_ID'){
        this.ApplicationID = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "APPLICATION_CODE"
          }
        );
      }
      if(x.FieldCode == 'APPLICATION_TYPE'){
        this.ApplicationType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName":  x.ColumnName,
            "field": "APPLICATION_TYPE_NAME"
          },
        );
      }
      if(x.FieldCode == 'PHYSICIAN_NAME'){
        this.PhysicianName = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "PhysicianName"
          }
        );
      }
      if(x.FieldCode == 'REQUEST_TYPE'){
        this.RequestType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "REQUEST_TYPE_NAME"
          }
        );
      }
    
      if(x.FieldCode == 'STATUS'){
        this.Status = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "STATUSStr"
          }
        );
      }

      if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
        this.TherapeuticArea = x.ColumnName;
        if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.IstMyApplications) {
          if (this.userPreferenceColumnsLst.IstMyApplications.THERAPEUTIC_AREA_ID) {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "THERAPEUTIC_AREA_NAME"
              }
            );
          }
        }

      }

      if (x.FieldCode == 'PRODUCTIDS') {
        this.Product = x.ColumnName;
        if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.IstMyApplications) {
          if (this.userPreferenceColumnsLst.IstMyApplications.PRODUCTIDS) {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "PRODUCT_NAME"
              },
            );
          }
        }
      }

      if (x.FieldCode == 'STUDY_TYPE') {
        this.StudyType = x.ColumnName;
        if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.IstMyApplications) {
          if (this.userPreferenceColumnsLst.IstMyApplications.STUDY_TYPE) {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "StudyType"
              },
            );
          }
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.IstMyApplications) {
        if (this.userPreferenceColumnsLst.IstMyApplications.SUBMITTED_ON && x.FieldCode == 'SUBMITTED_ON') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "SubmittedOnStr"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.IstMyApplications) {
        if (this.userPreferenceColumnsLst.IstMyApplications.LAST_UPDATED_ON && x.FieldCode == 'LAST_UPDATED_ON') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "LastUpdatedStr"
            }
          );
        }
      }
      })
      setTimeout(()=>{
      this.gridApi.refreshHeader();
      this.gridApi.sizeColumnsToFit();
      },500);
  }

  getUserPreferenceColumns(){
    this.commonService.GetUserPreferencesColumns().subscribe({
      next:res=>{
        if(res){
          this.userPreferenceColumnsLst = res;
        }
        this.setUserPreferenceColumns();
      }
    })
  }

  selectColumns($event){
      let modalRef = this.modalService.open(ColumnsSelectionPopupComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-md modal-dialog-center',
        animation: true
      });
      modalRef.componentInstance.Content = { columns: this.columns,moduleId:"2",isAllApplications: false};
      modalRef.result.then((result) => {
        this.getUserPreferenceColumns();
      });
  
    }
}
